export default __webpack_public_path__ + "b5379b28c1bfe878d1e2a6f5809b50a2.svg";